import AttendanceErrorPage from './AttendanceErrorPage';

export default AttendanceErrorPage;